import React, { useState, useReducer } from "react"
import Button from "@amzn/meridian/button"
import Icon from "@amzn/meridian/icon"
import clockTokens from "@amzn/meridian-tokens/base/icon/clock"
import {Translation, useTranslation} from "./Translation";
import Modal, { ModalFooter } from "@amzn/meridian/modal"
import Row from "@amzn/meridian/row"
import Text from "@amzn/meridian/text"
import {
    SCRUB_BUTTON_TYPE,
    SCRUB_CSV_DATE_FORMAT, SCRUB_INVOCATION_LIST_HEADERS, SCRUB_INVOCATION_LIST_HEADERS_CSV,
} from "../../commons/constants/ScrubConstants";
import {ScrubInvocationDetailsReducer} from "../../commons/reducer/ScrubInvocationDetailsReducer";
import {exportToCsv} from "../../handler/CsvHandler";
import {getFormattedDate} from "../../util/CommonUtils";
import {ScrubInvocationDetailsTable} from "./ScrubInvocationDetailsTable";
import Box from "@amzn/meridian/box";

const initialState = {
    items: [],
    loading: false
};


export const ScrubInvocationAttributesButton = ({view}) => {
    const [open, setOpen] = useState(false)
    const onClickScrubModalFooterButton = () => setOpen(false)
    const onCloseScrubModal = () => setOpen(false)
    const [{items}, dispatch] = useReducer(ScrubInvocationDetailsReducer, initialState);
    const tableHeaders = SCRUB_INVOCATION_LIST_HEADERS;

    const getScrubInvocationTableOutline = (scrubType) => {
        switch(scrubType) {
            case "IN_STATION":
                return <Translation stringId = "in_station_scrub_details"/> ;
            case "ON_ROAD":
                return <Translation stringId = "on_road_scrub_details"/> ;
            default:
                return <Translation stringId = "on_road_scrub_details"/> ;

        }
    }

    const translatedHeaders = SCRUB_INVOCATION_LIST_HEADERS_CSV[view]
        .map(([k, v]) => useTranslation({stringId:v.stringId}));

    const startScrub = (scrubType) => dispatch({
        type: "START_SCRUB",
        data: {
            dispatcher: dispatch,
            scrubType: scrubType
        }
    });

    const exportDataToCsv = (view) => {
    exportToCsv({
            title: `${SCRUB_BUTTON_TYPE[view].scrubType}-scrubInvocationDetails-${getFormattedDate(SCRUB_CSV_DATE_FORMAT)}`,
           headers: translatedHeaders,
            rows: items.map(item => SCRUB_INVOCATION_LIST_HEADERS_CSV[view].map(([k, v]) => item[k] || ""))}
        )};

    const downloadScrubInvocationDetails = (scrubType, view) => {
        startScrub(scrubType);
        setOpen(true);
    };


    return (
        <React.Fragment>
            <Button type="icon" onClick={() => downloadScrubInvocationDetails(SCRUB_BUTTON_TYPE[view].scrubType , view)}>
                <Icon tokens={clockTokens}/>
            </Button>
            <Modal
                width="100%"
                title={getScrubInvocationTableOutline(SCRUB_BUTTON_TYPE[view].scrubType)}
                open={open}
                onClose={onCloseScrubModal}
                scrollContainer="viewport"
                closeLabel="Close"
                describedById="modal-description"
            >
                <Text id="modal-description">
                    <Translation stringId="invocation_details_modal_description" />
                </Text>
                <Box>
                    <ScrubInvocationDetailsTable contents={items} translatedHeaders={translatedHeaders} headers={tableHeaders}/>
                </Box>
                <ModalFooter>
                    <Row alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="small" onClick={onClickScrubModalFooterButton}>
                            <Translation stringId="invocation_details_modal_cancel_button" />
                        </Button>
                        <Button type="primary" size="small" onClick={() => {exportDataToCsv(view)}}>
                            <Translation stringId="invocation_details_export_to_csv" />
                        </Button>
                    </Row>
                </ModalFooter>
            </Modal>
        </React.Fragment>

)
}



// WEBPACK FOOTER //
// ./src/components/scrub/scrubInvocationList.js